import { useState } from "react";
import useLogin from "../../customHooks/useLogin";

import { IoEye, IoEyeOff } from "react-icons/io5";
import { TailSpin } from "react-loader-spinner";
import almatin_img from "../../img/almatin_group.png";
import Footer from "../../components/Footer/Footer";
import "./login.scss";


function Login() {
  const { handleLogin, loading, errorMessage } = useLogin();

  //===State start here===
  const [jobId, setJobId] = useState("");
  const [password, setPassword] = useState("");
  const [rememberMe, setRememberMe] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  //===State end here===

  const handleSubmit = (e) => {
    e.preventDefault();
    handleLogin(jobId, password, rememberMe);
  };

  const isButtonDisabled = !jobId || !password;

  return (
    <div className="login_screen">
      <form className="login" onSubmit={handleSubmit}>
        <div className="login_header">
          <span>تسجيل الدخول</span>
        </div>

        <div className="login_container">
          <img src={almatin_img} alt="مجموعة المتين" className="img_login" />

          {errorMessage && (
            <span className="login_page_errorMessage" dir="rtl">{errorMessage}</span>
          )}

          <div className="login_input_container">
            <div className="login_field">
              <label htmlFor="login_job_id">الرقم الوظيفي</label>
              <input
                id="login_job_id"
                type="text"
                className="input_field_login"
                dir="rtl"
                value={jobId}
                onChange={(e) => setJobId(e.target.value)}
                autoComplete="username"
              />
            </div>

            <div className="login_field">
              <label htmlFor="login_password">كلمة المرور</label>
              <div className="login_password_wrap">
                <input
                  id="login_password"
                  type={showPassword ? "text" : "password"}
                  className="input_field_login"
                  dir="rtl"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  autoComplete="current-password"
                />
                <button
                  type="button"
                  className="login_eye"
                  onClick={() => setShowPassword((prev) => !prev)}
                  aria-label={showPassword ? "إخفاء كلمة المرور" : "إظهار كلمة المرور"}
                >
                  {showPassword ? <IoEyeOff /> : <IoEye />}
                </button>
              </div>
            </div>

            <label className="login_remember">
              <input
                type="checkbox"
                checked={rememberMe}
                onChange={() => setRememberMe((prev) => !prev)}
              />
              <span>تذكرني</span>
            </label>

            <button
              className="btn_for_login"
              type="submit"
              disabled={isButtonDisabled || loading}
            >
              {loading ? (
                <TailSpin visible height="24" width="24" color="#fff" ariaLabel="loading" radius="1" />
              ) : (
                "تسجيل الدخول"
              )}
            </button>
          </div>
        </div>
        <Footer className="login_footer"/>
        

        {/* <div className="login_footer">
          <div className="text_footer" dir="rtl">
            <div className="login_text_footer_name_section" dir="rtl">
              <span dir="rtl">تصميم و برمجة م. صالح الحايك و م. عماد زرز</span>
              <span dir="rtl">من قسم التقانة لمجموعة المتين</span>
            </div>
            <span className="login_copyright">Almatin.com &copy; { new Date().getFullYear() }</span>
          </div>
        </div> */}
      </form> 
    </div>
  );
}

export default Login;
